import Room from './Room';

export default Room;


// WEBPACK FOOTER //
// ./src/components/Room/index.js